module.exports = __webpack_public_path__ + "static/media/main_04.19cdf89e.png";